import { comment, forum } from '@/api'
import {
	FORUM_CATEGORIES_ERROR,
	FORUM_CATEGORIES_GET,
	FORUM_GET,
	FORUM_COMMENTS_GET,
	FORUM_CHOSE_CATEGORY,
	FORUM_CHOSE_CATEGORY_DELETE,
	FORUM_LOADING_STATUS,
	FORUMS_GET,
	FORUM_POST_ADD_STATUS,
	FORUM_POST_ADD,
	FORUM_POST_ADD_ERROR,
	FORUM_COMMENT_ADD_STATUS,
	FORUM_COMMENT_ADD,
	FORUM_COMMENT_ADD_ERROR,
	FORUM_EDIT_LOADING_STATUS,
	FORUM_ACTIVE_COMMENT,
} from '@/store/forum/types'

const setActiveComment = ({ commit }, payload) => {
	try {
		commit(FORUM_ACTIVE_COMMENT, payload)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const fetchForumCategories = async (ctx, filters) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data, headers } = await forum.fetchForumCategories(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(FORUM_CATEGORIES_GET, response)
		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const fetchForums = async (ctx, query) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data, headers } = await forum.fetchForums(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(FORUMS_GET, response)
		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const getForum = async (ctx, forumId) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data: forumData } = await forum.getForum(forumId)
		const { data: forumCommentData } = await forum.getForumComments(forumId)

		ctx.commit(FORUM_GET, forumData)
		ctx.commit(FORUM_COMMENTS_GET, forumCommentData)

		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const addComment = async (ctx, commentData) => {
	ctx.commit(FORUM_COMMENT_ADD_STATUS, true)
	try {
		const { data } = await comment.addComment(commentData)

		ctx.commit(FORUM_COMMENT_ADD_STATUS, false)
		ctx.commit(FORUM_COMMENT_ADD, data)
	} catch (e) {
		ctx.commit(FORUM_COMMENT_ADD_ERROR, e)
		throw e
	}
}

const addPost = async (ctx, postData) => {
	ctx.commit(FORUM_POST_ADD_STATUS, true)
	try {
		const { data } = await forum.addPost(postData)

		ctx.commit(FORUM_POST_ADD_STATUS, false)
		ctx.commit(FORUM_POST_ADD, data)
		const credentials = JSON.parse(localStorage.getItem('settings')).dwh.value
		ctx.dispatch(
			'settings/sendDwhAction',
			{
				credentials,
				payload: {
					category: 'Content',
					action: 'create_forum_post',
					module: 'Forums',
					session_id: ctx.rootGetters['app/sessionId'],
					version: process.env.VUE_APP_VERSION,
					platform: 'web app',
					login: credentials.login,
					data: data.forum_id,
				},
			},
			{ root: true }
		)
	} catch (e) {
		ctx.commit(FORUM_POST_ADD_ERROR, e)
		throw e
	}
}

const chosenCategory = async (ctx, categoryId) => {
	try {
		ctx.commit(FORUM_CHOSE_CATEGORY, categoryId)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const deleteChosenCategory = async (ctx) => {
	try {
		ctx.commit(FORUM_CHOSE_CATEGORY_DELETE)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const editForum = async (ctx, payload) => {
	try {
		ctx.commit(FORUM_EDIT_LOADING_STATUS, true)
		const { data } = await forum.editForum(payload)
		ctx.commit(FORUM_GET, data)
		return true
	} catch (e) {
		console.log(e)
		return false
	} finally {
		ctx.commit(FORUM_EDIT_LOADING_STATUS, false)
	}
}

export default {
	fetchForumCategories,
	fetchForums,
	getForum,
	addComment,
	chosenCategory,
	deleteChosenCategory,
	addPost,
	editForum,
	setActiveComment,
}
